import { WithWorkspaceId } from '~/types/common';
import { SlackChannel } from '~/types/resources';
import { integrationNotificationApi, integrationSlackApi } from '~/utils/api';

export interface SlackResponse {
  channels: SlackChannel[];
  linked: boolean;
}

export interface SlackChannelResponse {
  workspaceId: string;
  processid: string;
  successfulRuns: { channelId: string }[];
  failedRuns: { channelId: string }[];
}

export enum NotificationType {
  SUCCESSFUL_RUNS = 'SUCCESSFUL_RUNS',
  FAILED_RUNS = 'FAILED_RUNS',
}

export const linkToSlack = async ({
  workspaceId,
  link,
}: { link: { state: string; code: string } } & WithWorkspaceId) =>
  integrationSlackApi.post<SlackResponse>(`/workspaces/${workspaceId}/slack`, {
    ...link,
    redirectUri: window.location.href.replace(/(\?.*)/, ''),
  });

export const unlinkFromSlack = async ({ workspaceId }: WithWorkspaceId) =>
  integrationSlackApi.delete(`/workspaces/${workspaceId}/slack`);

export const listSlackChannels = async ({ workspaceId }: WithWorkspaceId) =>
  integrationSlackApi.get<SlackResponse>(`/workspaces/${workspaceId}/slack`, {});
export const getSlackChannelInfo = async ({
  workspaceId,
  channelId,
}: { channelId: string } & WithWorkspaceId) =>
  integrationSlackApi.get(`/workspaces/${workspaceId}/slack/${channelId}`, {});

export const changeSlackChannel = async ({
  workspaceId,
  channels,
  processId,
}: {
  channels: { successfulRuns?: { channelId: string }[]; failedRuns?: { channelId: string }[] };
  processId: string;
} & WithWorkspaceId) =>
  integrationNotificationApi.post<{
    successfulRuns: { channelId: string }[];
    failedRuns: { channelId: string }[];
  }>(`/workspaces/${workspaceId}/slack`, {
    processId,
    successfulRuns: channels.successfulRuns || [],
    failedRuns: channels.failedRuns || [],
  });

export const getSlackChannel = async ({
  workspaceId,
  processId,
}: { processId: string } & WithWorkspaceId) =>
  integrationNotificationApi.get<SlackChannelResponse>(`/workspaces/${workspaceId}/slack`, {
    processId,
  });

export const removeSlackChannel = async ({
  workspaceId,
  params: queryParams,
}: {
  params: {
    processId: string;
    channelId: string;
    notificationType: NotificationType;
  };
} & WithWorkspaceId) =>
  integrationNotificationApi.delete<{
    successfulRuns: { channelId: string }[];
    failedRuns: { channelId: string }[];
  }>(`/workspaces/${workspaceId}/slack`, queryParams);
